module.exports = __webpack_public_path__ + "img/piec_lat_gwarancji.bfc77947.jpg";